export const configApi = {
	apiUrl: 'https://api.ticketshop.com.co/api/' // Servidor Final
 	// apiUrl: 'https://apicli-col.ticketsshop.com.co/api/' // Servidor de pruebas
	//apiUrl: 'https://apicli-col.ticketsshop.com.co/api/' // Servidor de pruebas
};